/**
 * How long free-text fields may be - the backend checks the same limits
 * (core/TextLimits). The long one is for what pilot users asked to write at
 * length: a project's description and what a milestone releases.
 */
export const LONG_DESCRIPTION = 4000;

/** Phase, deliverable and task descriptions. */
export const SHORT_DESCRIPTION = 1000;
